import template from '../../../../views/template/default/default.html';
export default class TemplateCreateCtrl {
    constructor($scope, $filter, SideMenu, Template, Events, $state) {
        SideMenu.setActive('template');

        Template.getList().then(templates => {
           let userTemplatesNames = templates.data
               .filter(template => !template.templateType && !template.global)
               .map(template => template.name);

            let newTemplateName = $filter('getNumberedName')(userTemplatesNames, 'New');

            this.defaultTemplate = {
                'name': newTemplateName,
                'plain': btoa('plain text'),
                'html': btoa(template)
            };

            return Template.store(this.defaultTemplate).then((result) => {

                if (result.data) {
                    Events.flashEvent('notification', "Created");
                    $state.go('template.edit', { id: result.data.id });
                }
            });
        }).catch( error => {
            let errorMessage = $filter('translate')('GLOBAL:ERROR:DEFAULT');
            if (error.data && error.data.code === 9) {
                errorMessage = error.data.message || errorMessage;
            }
            Events.flashEvent('error', errorMessage);
        });

    }
};
